import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';

import { SearchTypeahead } from 'src/common/SearchTypeahead';

import { setUnassignedTripsSearchTerm } from '../dispatcher.slice';

export function UnAssignedTripSearch() {
  const dispatch = useDispatch();
  const debounceSearch = debounce(handleSearch, 300);

  function handleSearch(term: string) {
    dispatch(setUnassignedTripsSearchTerm(term));
  }

  return (
    <>
      <SearchTypeahead
        placeholder="Search unassigned trips"
        onChange={debounceSearch}
      />
    </>
  );
}
